// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"19":"richtext","736":"vendor"}[chunkId] || chunkId) + "." + {"19":"c6bd3e48","136":"f23e710d","147":"ad77acea","219":"2dd5c946","267":"6da83db7","416":"c3a9c2c5","482":"c35062e0","736":"2f4bb386","840":"938394ae","967":"1c347e3f"}[chunkId] + ".chunk.js";
};